import api, { TableColluns, TipoGrafico } from "./api";

export interface AreaExecutiveSummaryResult {
    descricaoDiretoria: string;
    variacao: number;
    forecastAno: number;
    orcadoAno: number;
    naoPrevisto: number;
    totalProjeto: number;
    mesAno: string;
    siglaDiretoria: string;
    siglaArea: string;
    siglaDepartamento: string;
    graficoTipoPacote: GraficoTipoPacote;
    tipoProjetoForecast: AreaExecutiveSummaryTipoProjetoForecastResult;
    resumoCapEx: GraficoAreaExecutiveSummaryResumoCapExResult;
    graficoCurva: AreaExecutiveSummaryCurvaEconomicaResult
}

export interface GraficoTipoPacote {
    graficoBarra: TipoGrafico;
    dataSourceResult: Array<AreaExecutiveSummaryTipoPacoteResult>;
    collunas: Array<TableColluns>;
}

export interface AreaExecutiveSummaryTipoPacoteResult {
    totalMateria: number;
    totalServico: number;
    totalEsquipamento: number;

}

export interface AreaExecutiveSummaryTipoProjetoForecastResult {
    series: Array<SeriesData>;
}

export interface SeriesData {
    name: string,
    y: number,
}


export interface GraficoAreaExecutiveSummaryResumoCapExResult {
    capEx: number;
    contHidden: number;
    execu: number;
    execuHidden: number;
    reqs: number;
    reqsHidden: number;
    toCont: number;
    toContHidden: number;
    forecast: number;
    balance: number;
    sadoCapex: number;
}


export interface AreaExecutiveSummaryCurvaEconomicaResult {
    collunsTable: Array<TableColluns>,
    tableDataSource: Array<any>,
    categorias: Array<string>,
    series: Array<any>,
}

export interface FiltroPesquisaAreaExecutiveSummaryFromProps {
    diretoriaId?: string;
    areaId?: string;
    departamentoId?: string;
    fechamentoId?: string;
    telaInicial: boolean;
}


export const getAreaExecutiveSummaryByUserId = (filtro: FiltroPesquisaAreaExecutiveSummaryFromProps) => api.get<AreaExecutiveSummaryResult>('areaExecutiveSummary/getAreaExecutiveSummaryByUserId', { ...filtro });
export const getAreaExecutiveSummary = (filtro: FiltroPesquisaAreaExecutiveSummaryFromProps) => {
    return api.get<AreaExecutiveSummaryResult>('areaExecutiveSummary/getAreaExecutiveSummary', { ...filtro });
};

